import PropTypes from 'prop-types'
import { Element } from '../../../../common/html/element'
import classes from './index.module.scss'

export const Filter = ({ renderLeft, renderRight }) => {
  return (
    <Element
      className={classes.container}
      style={{ borderBottomColor: '#e5e5e8' }}
    >
      <div>{renderLeft && renderLeft()}</div>

      <Element className={classes.right} style={{ color: '#3a414b' }}>
        {renderRight && renderRight()}
      </Element>
    </Element>
  )
}

Filter.propTypes = {
  renderLeft: PropTypes.func,
  renderRight: PropTypes.func,
}
